const languageOptions = [
  { value: 'uk', label: <span>Ua</span> },
  { value: 'en', label: <span>En</span> }
  // { value: 'fr', label: <span>Fr</span> },
  // { value: 'ger', label: <span>Ger</span> }
];

export default languageOptions;
